import Vue from "vue";
import VueI18n from "vue-i18n";
import pt from './pt';
import es from './es';

Vue.use(VueI18n);

let language = window.navigator.language || window.navigator.userLanguage;
language = language.substring(0, 2);
if (['pt', 'es'].indexOf(language) == -1) {
    language = 'pt';
}

export default new VueI18n({
  locale: language,
  messages: {
    pt,
    es
  }
});